import { render, staticRenderFns } from "./SalonClients.vue?vue&type=template&id=0b763454&scoped=true"
import script from "./SalonClients.vue?vue&type=script&lang=ts"
export * from "./SalonClients.vue?vue&type=script&lang=ts"
import style0 from "./SalonClients.vue?vue&type=style&index=0&id=0b763454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b763454",
  null
  
)

export default component.exports